import React from 'react'
import { MenuItemType } from '@utils/types'
import { getIcon } from '@utils/icons'
import {
  WImage,
  Button,
  EditableTitle,
  EditableDescription,
  // EditableVideo,
  WContainer,
} from '@components/atoms'
import styles from './BannerSmall.module.sass'

interface Props {
  item: MenuItemType
  theme?: 'light' | 'dark'
  mediaPos?: 'left' | 'right'
  editMode?: boolean
  className?: string
}

const BannerSmall = (props: Props) => {
  const {
    item = undefined,
    theme = 'light',
    mediaPos = 'left',
    editMode = false,
    className = '',
  } = props

  return item ? (
    <div
      className={`${styles.root} ${styles[`root--${theme}`]} ${styles[`root--media-${mediaPos}`]} ${
        editMode ? styles['root--editMode'] : ''
      } ${className}`}
    >
      <WContainer>
        <div className={`${styles.layout}`}>
          {/* {(item.video.provider === 'local' && item.video?.url) || (item.video.provider !== 'local' && item.video?.videoId) ? (
            <div className={`${styles.videoBox}`}>
              <EditableVideo
                item={item.video}
                preserveRatio
                editMode={editMode}
                className={styles.video}
              />
            </div>
          ) : ( */}
          <div className={`${styles.imageBox}`}>
            {!!item.image && (
              <WImage
                src={item.image}
                maxWidth={400}
                maxHeight={400}
                objectFit="contain"
                alt={item?.imageAlt}
                title={item?.imageAlt}
              />
            )}
          </div>
          {/* )} */}
          <div className={styles.main}>
            {((!!item.intro && !!item.name) || !!item.description) && (
              <div className={styles.content}>
                <EditableTitle
                  title={item.intro}
                  variant="p"
                  className={styles.intro}
                  editMode={editMode}
                />
                <EditableTitle title={item.name} className={styles.title} editMode={editMode} />
                <EditableDescription
                  description={item.description}
                  className={styles.description}
                  editMode={editMode}
                />
              </div>
            )}
            {editMode ? (
              <>{item.children}</>
            ) : item.children?.length > 0 ? (
              <div className={`${styles.list}`}>
                {item.children?.map((x) => (
                  <Button
                    label={x.ctaLabel}
                    href={x.url}
                    newPage={x.blank}
                    theme={theme}
                    variant={x.variant}
                    icon={x.icon}
                    iconPos={x.iconPos}
                    size="lg"
                  />
                ))}
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </WContainer>
    </div>
  ) : (
    <></>
  )
}

export default BannerSmall
